import { render } from "./MiStepperNavigation.vue?vue&type=template&id=a4f35322"
import script from "./MiStepperNavigation.vue?vue&type=script&lang=js"
export * from "./MiStepperNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QStepperNavigation});
